import './team.scss';
import { on_ready } from 'src/js/utils';
import Popup_Content from './popup'; 
 
on_ready(()=>{  
    team_info();
    console.log('teams');
    
});
 

function team_info(){    

    // const data = JSON.parse(posts_content); 
    let data = posts_content;
    if (typeof posts_content === 'string') {
        try {
            data = JSON.parse(posts_content);
        } catch (e) {
            console.error('Failed to parse posts_content:', e);
            data = [];
        }
    }

    const popup = new Popup_Content('.posts_popup_content');

    //console.log('data',data);
    
    // items
    document.querySelectorAll('.item-team-2').forEach(item=>{
        const item_data = data.find(element=>element.id == item.dataset.postid);
        item.addEventListener('click', ()=>{
            popup.open(item_data)
        })
    })
}


